export default __webpack_public_path__ + "static/media/positive-icon.68cc47f0.svg";